export default __webpack_public_path__ + "static/media/92t.c76f8cef.jpg";